import a1 from "./dallas-juice-buying-guide.json";
import a2 from "./organic-juice-companies-dallas.json";
import a3 from "./cold-pressed-vs-regular-juice.json";
import a4 from "./juice-vs-smoothie.json";
import a5 from "./juice-subscriptions-dallas.json";
import a6 from "./juice-pickup-vs-delivery-dallas.json";
import a7 from "./gym-juice-pickup-dallas.json";
import a8 from "./build-mixed-juice-pack.json";
import a9 from "./cold-pressed-juice-storage.json";
import a10 from "./reading-juice-labels.json";
import a11 from "./green-juice-dallas.json";
import a12 from "./beet-juice-flavor-guide.json";
import a13 from "./pineapple-juice-blends.json";
import a14 from "./watermelon-juice-blends.json";
import a15 from "./blue-spirulina-juice.json";
import a16 from "./citrus-ginger-juice.json";
import a17 from "./juice-with-creatine.json";
import a18 from "./juice-with-clear-protein.json";
import a19 from "./bcaa-juice-guide.json";
import a20 from "./juice-around-workouts.json";
import a21 from "./juice-cleanses-dallas-questions.json";
import a22 from "./juice-for-dallas-workweek.json";
import a23 from "./juice-for-small-gatherings.json";
import a24 from "./compare-juice-prices-dallas.json";
import a25 from "./local-juice-company-checklist.json";

export const ARTICLES = [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19, a20, a21, a22, a23, a24, a25];
export const bySlug = Object.fromEntries(ARTICLES.map((a) => [a.slug, a]));
export const SECTIONS = ["Buying guides", "Juice basics", "Flavors & ingredients", "Functional additions", "Pickup & planning"];

// Product detail pages -> related editorial guides
export const PRODUCT_GUIDES = {
  "tropical-recovery": ["pineapple-juice-blends", "juice-with-clear-protein", "cold-pressed-vs-regular-juice"],
  "hydrate-plus": ["watermelon-juice-blends", "juice-with-clear-protein", "juice-around-workouts"],
  "electric-sun": ["blue-spirulina-juice", "green-juice-dallas", "juice-with-clear-protein"],
  "flow-plus": ["beet-juice-flavor-guide", "juice-with-creatine", "dallas-juice-buying-guide"],
  "citrus-drive": ["citrus-ginger-juice", "bcaa-juice-guide", "juice-around-workouts"],
  "renew-plus": ["green-juice-dallas", "juice-cleanses-dallas-questions", "dallas-juice-buying-guide"],
};
